
export default {
  name: 'BlockNotFound',

  props: {
    message: {
      type: String,
      default: '',
    },
    buttonLabel: {
      type: String,
      default: '',
    },
  },

  methods: {
    click: function () {
      this.$emit('clickButton');
    },
  },
};
